<template>
	<div class="home-intro pt-60">
		<h2 class="member-t">30万+寄售行的信赖之选</h2>
		<p class="member-p font-red">实际落地应用广泛，助力门店数字化升级更安心</p>
		<div class="store-row quick_wrap-row">
			<img v-for="(item, i) in storeImgArr1" :key="i" class="store-img" :src="item" alt="" />
		</div>
		<div class="store-row store-row1 quick_wrap-row">
			<img v-for="(item, i) in storeImgArr2" :key="i" class="store-img" :src="item" alt="" />
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			
		},
		data() {
			return {
				storeImgArr1: [
					require('../../static/home/store-icon1.png'),
					require('../../static/home/store-icon2.png'),
					require('../../static/home/store-icon3.png'),
					require('../../static/home/store-icon4.png'),
					require('../../static/home/store-icon5.png'),
				],
				storeImgArr2: [
					require('../../static/home/store-icon6.png'),
					require('../../static/home/store-icon7.png'),
					require('../../static/home/store-icon8.png'),
					require('../../static/home/store-icon9.png'),
					require('../../static/home/store-icon10.png'),
				]
			}
		},
		methods: {
		}
	}
</script>

<style scoped>
.home-intro {
	background-color: #fff;
}	
.member-t {
	font-weight: 600;
	font-size: 40px;
	color: #333333;
	text-align: center;
}
.member-p {
	font-weight: 600;
	font-size: 14px;
	color: #999999;
	margin-bottom: 80px;
	text-align: center;
}
.quick_wrap-row {
	width: 1200px;
	margin: 0 auto;
}
.store-row {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
}
.store-row .store-img {
	flex: 1;
	height: 224px;
	margin-right: 20px;
	vertical-align: middle;
	cursor: pointer;
	transition: transform 0.3s ease; 
}
.store-row1 {
	margin-bottom: 0;    
	padding-bottom: 60px;
}
.store-row1 .store-img {
	mask-image: linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0)); /* 从不透明到透明的渐变 */
	-webkit-mask-image: linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0)); /* Safari浏览器兼容性 */
}
.store-row .store-img:hover {
	transform: scale(1.08);
	-webkit-mask-image: linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,1));
	mask-image: linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,1));
}
</style>


// WEBPACK FOOTER //
// src/components/StoreImg.vue